<template>
    <RedesignRadioGroup v-model="localValue">
        <RedesignRadioButton label="1">
            {{ $t('general.enabled') }}
        </RedesignRadioButton>
        <RedesignRadioButton label="0">
            {{ $t('general.disabled') }}
        </RedesignRadioButton>
    </RedesignRadioGroup>
</template>

<script setup lang="ts">
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import { useVModel } from '@vueuse/core'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'

const props = defineProps<{
    value?: string | number
}>()

const emit = defineEmits([ 'input', 'update:value' ])

const localValue = useVModel(props, 'value', emit, { eventName: 'input' })
</script>
